import { Note } from '../models/note';
import { SubjectType } from '../models/subject-type';
import { SubjectLink } from '../models/subject-link';
import { SubjectReferral } from '../models/subject';

export interface IEntity {
  id: number;
  uid: string;
}

export interface IObjectState {
  objectState: ObjectState;
}

export interface IEntityList {
  items: IEntity[];
  totalCount: number;
}

export interface INote extends IEntity {
  noteId: number;
  sequenceId: number;
  readOnly: boolean;
  note: Note;
}

export interface IParentEntity extends IEntity {
  type: string;
  summary: string;
  subjectType?: string;
  url?: string;
  hasCasePreparationFile?: boolean;
}

export interface IEntityWithLinks extends IEntity {
  reference: string;
  summary: string;
  subjectType: SubjectType;
  subjectLinks: SubjectLink[];
  isReferral: boolean;
  subjectReferrals: SubjectReferral[];
}

export enum ObjectState {
  Unchanged,
  Added,
  Modified,
  Deleted,
}
